import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import ForecastDialog from 'components/ForecastDialog';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import Online from 'components/Online';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import SchemasWithEventTypeIdExistGate from 'components/SchemasWithEventTypeIdExistGate';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Child
// @ts-ignore
import ForecastsTable from './components/ForecastsTable';
// @ts-ignore
import ForecastsPagination from './components/ForecastsPagination';
// @ts-ignore
import ForecastsRequest from './components/ForecastsRequest';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const BinForecasts = (): React.ReactElement => (
    <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
        <ErrorBoundary
            namespace="BinForecasts"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <SchemasWithEventTypeIdExistGate
                FallbackComponent={<Redirect to="/" />}
            >
                <Helmet>
                    <title>
                        Bin Forecasts -
                        {' '}
                        {REACT_APP_PROJECT_NAME}
                    </title>
                </Helmet>
                <Online>
                    <ForecastsRequest />
                </Online>
                <PageTitleAndFilters
                    title="Bin Forecasts"
                    searchInputPlaceholder="Search (e.g. lot, RPIN, variety)"
                    currentEntity
                    currentSeason
                    variety
                    entity
                />
                <PageWrapper top={0} bottom={50}>
                    <LoadingGate
                        namespace="QUANTITY_FORECASTS_LOAD"
                        LoadingComponent={
                            <PageWrapper>
                                <Loader active inline="centered" />
                            </PageWrapper>
                        }
                    >
                        <ErrorGate namespace="QUANTITY_FORECASTS_LOAD">
                            <ForecastsTable />
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginLeft: 'auto' }}>
                                    <TableCountDropdown defaultCount={25} />
                                    <ForecastsPagination />
                                </div>
                            </div>
                            <CurrentSeasonInProgressGate>
                                <ForecastDialog />
                            </CurrentSeasonInProgressGate>
                        </ErrorGate>
                    </LoadingGate>
                </PageWrapper>
            </SchemasWithEventTypeIdExistGate>
        </ErrorBoundary>
    </RoleGate>
);

export default BinForecasts;
